import {initItemcardImages} from "../../../default/global/js/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink, triggerCopyText} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {init360Images} from "../../../default/global/js/init360Images";
import {openFullscreenGallery} from "../../../reusch_global/js/global/fullscreengallery";
import Swiper from 'swiper';
import {EffectCoverflow, Scrollbar, Pagination} from 'swiper/modules';
import {videoLazy} from "../../../reusch_global/js/global/videoLazy";

window.addEventListener("load", (event) => {
    //initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    triggerCopyText();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();
    sizeSelect();
    initPerformanceSwiper();
    resizeItemcard();
    videoLazy();

    for (let item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
    }
});

function sizeSelect() {
    let sizeVariantWrapper = document.querySelector(".sizeVariantsWrapper");
    if(sizeVariantWrapper) {
        let variantSelection = sizeVariantWrapper.querySelector(".js-sizeVariantSelection");
        let selectedSize = sizeVariantWrapper.querySelector(".js-selectedSize");
        let sizeItems = sizeVariantWrapper.querySelectorAll(".js-variantSizeItem");
        for(let sizeItem of sizeItems) {
            if(sizeItem.classList.contains("selected")) {
                let sizeValue = sizeItem.querySelector(".variantSelection__item");
                if(sizeValue) {
                    selectedSize.innerHTML = sizeValue.innerHTML;
                }
            }
        }

        document.addEventListener('click', event => {
            if (!sizeVariantWrapper.contains(event.target)) {
                variantSelection.classList.remove("active");
            }
        });

        sizeVariantWrapper.addEventListener('click', function (event) {
            variantSelection.classList.toggle("active");
        });
    }
}


function initPerformanceSwiper() {
    const performances = document.querySelectorAll('.performanceCollectionContainer');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const videos = document.querySelectorAll(".performanceCollectionContainer video");
                const mobile = window.innerWidth <= 1024;

                videos.forEach(video => {
                    video.setAttribute('preload', 'auto');
                    let hoverPlayTimeout;

                    if (!mobile) {
                        video.addEventListener("mouseenter", () => {
                            hoverPlayTimeout = setTimeout(() => {
                                video.play().catch(console.error);
                            }, 50);
                        });
                        video.addEventListener("mouseleave", () => {
                            clearTimeout(hoverPlayTimeout);
                            video.pause();
                        });
                    }

                    video.addEventListener("click", function () {
                        if(video.paused) {
                            video.play();
                        } else {
                            video.pause();
                        }
                    });
                });

                Swiper.use([Scrollbar]);
                const el = document.querySelector(".performanceSwiper");
                if(el) {
                    return new Swiper(el, {
                        spaceBetween: 20,
                        slidesPerView: 5,
                        loop: true,
                        navigation: {
                            nextEl: el.querySelector('.swiper-button-next'),
                            prevEl: el.querySelector('.swiper-button-prev'),
                        },
                        scrollbar: {
                            el: ".performanceScrollbar",
                            hide: false
                        },
                        breakpoints: {
                            0: {
                                slidesPerView: 1.2,
                                slidesOffsetAfter: 20
                            },
                            768: {
                                slidesPerView: 3,
                                slidesOffsetAfter: 0
                            },
                            1250: {
                                slidesPerView: 4,
                            },
                            1540: {
                                slidesPerView: 5,
                            }
                        },
                        on: {
                            init: function (swiper) {
                                const minSlides = swiper.params.slidesPerView + 1;

                                const realSlides = swiper.wrapperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
                                const realCount = realSlides.length;

                                if (realCount < minSlides) {
                                    const needed = Math.ceil(minSlides / realCount);

                                    const originalHtml = Array.from(realSlides)
                                        .map(slide => slide.outerHTML)
                                        .join('');

                                    for (let i = 0; i < needed - 1; i++) {
                                        swiper.wrapperEl.insertAdjacentHTML('beforeend', originalHtml);
                                    }

                                    swiper.update();
                                }

                                if (mobile) {
                                    playVideoInActiveSlide(swiper);
                                }
                            },
                            slideChange: function (swiper) {
                                if (mobile) {
                                    playVideoInActiveSlide(swiper);
                                }
                            }
                        }
                    });
                }
                observer.unobserve(entry.target);
            }
        });
    }, {threshold: 0});
    performances.forEach(element => observer.observe(element));

}

function playVideoInActiveSlide(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const videos = swiper.el.querySelectorAll('video');

    videos.forEach(video => {
        video.pause();
    });

    if (activeSlide) {
        const video = activeSlide.querySelector('video');
        if (video) {
            const source = video.querySelector('source[data-src]');
            if (source && !source.src) {
                source.src = source.dataset.src;
                video.load();
            }
            video.play().catch(console.error);
        }
    }
}

function resizeItemcard() {
    const resizeObserver = new ResizeObserver((entries) => {

        let mobile = false;
        if (window.innerWidth <= 768) {
            mobile = true;
        }
        itemcardImagesSwiper(mobile);
        extendBodyHeight(mobile);
    });

    resizeObserver.observe(document.body);
}

function itemcardImagesSwiper(mobile) {
    let itemcardImagesMain = document.querySelector(".js-itemcardImagesMain");
    if(itemcardImagesMain && mobile && !itemcardImagesMain.classList.contains("swiper-initialized")) {
        Swiper.use([Pagination]);
        const swiperItemcardImages = new Swiper(itemcardImagesMain, {
            slidesPerView: 1,
            loop: true
        });
    }

    if(itemcardImagesMain && !mobile && itemcardImagesMain.classList.contains("swiper-initialized")) {
        itemcardImagesMain.swiper.destroy();
    }

    if(itemcardImagesMain) {
        const slides = itemcardImagesMain.querySelectorAll(".js-itemcardOpenGallery");
        let i = 1;
        if(slides.length > 1) {
            for(const slide of slides) {
                if (!slide.hasAttribute('data-index')) {
                    slide.setAttribute('data-index', i);
                }
                i++;
            }
        }
    }
}

function extendBodyHeight(mobile) {
    const body = document.querySelector("body");
    if(mobile) {
        const stickyBox = document.querySelector(".orderbox_button");
        if(stickyBox) {
            body.style.paddingBottom = stickyBox.offsetHeight + "px";
        }
    } else {
        body.style.paddingBottom = "0px";
    }
}